<template>
  <div class="top-header__button">
    <v-btn
      text
      ripple
      :color="'#fff'"
      :to="link"
    >
      <v-icon>{{ icon }}</v-icon>
      <span class="top-header__button-text">{{ text }}</span>
    </v-btn>
  </div>
</template>

<script>
  export default {
    name: 'HeaderButton',
    props: {
      icon: {
        required: true,
      },
      text: {
        required: true,
        type: String,
      },
      link: {
        required: true,
      },
    },
  }
</script>

<style lang="sass" scoped>
  .v-icon
    margin-right: 5px

  .theme--light.v-btn--active::before
    opacity: 0

  @media (max-width: 960px)
    .top-header__button-text
      display: none
</style>
